import { TabContent as _TabContent, TabContentProps as _TabContentProps } from "reactstrap";

    export const TabContent = _TabContent;
    export type TabContentProps = _TabContentProps;
    